import './style.less';

export default function($log) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  function activate() {
    $log.debug('Bundle Info Component Activated');
    $log.debug('Bundle Info Component Data', vm.ngModel);
    vm.loaded = true;
    vm.error = {};
  }
}



// WEBPACK FOOTER //
// ./src/app/components/bundleInfo/controller.js